export interface Props {
    children: any;
    type?: ButtonTypes;
    className?: string;
    onClick?: Function;
    ariaLabel?:string;
    icon?: {
        type: ButtonIconTypes;
        value: any;
    };
    disabled?: boolean;
    size?: ButtonSizes;
    style?: ButtonStyles;
    styles?: object;
    variant?: ButtonVariants;
    layout?: ButtonLayouts;
    loading?: boolean;
    buttonProps?: any;
}

export enum ButtonTypes {
    Button = 'button',
    Submit = 'submit',
    Reset = 'reset',
}

export enum ButtonStyles {
    Primary = 'primary',
    Secondary = 'secondary',
}

export enum ButtonVariants {
    Primary = 'primary',
    Outline = 'outline',
}

export enum ButtonLayouts {
    Default = 'default',
    Wide = 'wide',
    Block = 'block',
}

export enum ButtonSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum ButtonIconTypes {
    Image = 'image',
    Element = 'element',
}

export interface ListProps extends Props {
    key: string;
}
